import React, { useState } from "react";
import { ReactComponent as Deleteicon } from "../../../../assets/icons/Deletered.svg";
import { deactivateAcc } from "../../../../api/settings";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import DeleteMemberModal from "../../../../components/common/modalMember";

const Delete = () => {
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const hideModal = () => {
    setIsModalOpen(false);
  };
  const YesClickHandler = async () => {
    setIsModalOpen(false);
    handleDelete();
  };
  const handleDelete = async () => {
    const res = await deactivateAcc(accessToken);
    if (res?.deactivation?.isDeactivated) {
      localStorage.removeItem("accessToken");
      message.success("Deactivated");
      navigate("/login");
    } else {
      message.error("Cant be deactivated");
    }
  };

  return (
    <>
      <div className={`relative ${isModalOpen ? "blur-sm" : ""}`}>
        <div className="px-3">
          <div>
            <div>
              <p className="text-lg font-medium tracking-wider">
                Delete Account
              </p>
              <div className="flex border-solid border-inputFieldGrey rounded-sm items-center p-2  lg:px-5">
                <p>
                  If You Delete Your Account You Have The Option To Recover It
                  Within 30 Days
                </p>
                <div className="ml-auto hover:cursor-pointer">
                  <Deleteicon onClick={showModal} />
                </div>
                {isModalOpen && (
                  <DeleteMemberModal
                    title={"Deactivate Account?"}
                    text={"Do you you want to Deactivate your Account?"}
                    onCancel={hideModal}
                    onOk={YesClickHandler}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Delete;
